import SignaturePad from 'signature_pad/dist/signature_pad.js';

///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('#signature-form-js')) {
      const signaturePad = new SignaturePad(document.getElementById('signature-pad-canvas-js'), {
        backgroundColor: 'rgb(255,255,255)',
        penColor: 'rgb(0,0,0)'
      });

      document.querySelector('#signature-pad-save-js').addEventListener('click', function(event) {
        if (signaturePad.isEmpty()) {
          alert('Please add signature before attempting to save.');
          event.preventDefault();
        } else {
          document.querySelector('#signature-pad-input-js').value = signaturePad.toDataURL();
          document.querySelector('#signature-form-js').submit();
        }
      });

      document.querySelector('#signature-pad-clear-js').addEventListener('click', function(event) {
        if (signaturePad.isEmpty()) {
          alert('Signature pad is already clear.');
          event.preventDefault();
        } else {
          signaturePad.clear();
          document.querySelector('#signature-pad-input-js').value = '';
        }
      });
    }
  });
}());
